export default "__VITE_ASSET__Bnudh7kM__"